import { AppButton } from '@/ui/buttons';
import { DoughnutChart } from '@/ui/charts/doughnut-chart';
import { FlexContainer } from '@/ui/styled-ui';
import { headingLargeFontSize } from '@/utils/helpers/css-variables.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledRetakeContainer = styled(FlexContainer)`
  .min-score-text {
    margin: 0;
    font-size: var(--default-font-size);
  }
`;

type ContentRetakeScreenProps = {
  minimumScore: number;
  score?: number;
  isRetakeDisabled?: boolean;
  onRetake: () => void;
};

export const ContentRetakeScreen: React.FC<ContentRetakeScreenProps> = ({
  minimumScore,
  score,
  isRetakeDisabled,
  onRetake,
}) => {
  const { t } = useTranslation();
  const docStyle = getComputedStyle(document.documentElement);

  return (
    <StyledRetakeContainer direction="column" gap={20} className="m-auto">
      <h1
        style={{
          fontSize: headingLargeFontSize(docStyle),
        }}
        className="mb-5"
      >
        {t('content.retake.heading', {
          percent: minimumScore,
        })}
      </h1>
      <p className="min-score-text">{t('content.yourScore')}</p>
      <DoughnutChart
        id="score"
        width="150"
        cutout="90%"
        isPercentCount
        singleCount={score || 0}
        allCount={100}
        minScore={minimumScore}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: t('content.retake.p', {
            percent: `<strong>${minimumScore}%</strong>`,
          }),
        }}
        className="min-score-text text-center mt-5"
      />
      <AppButton
        label={t('content.retake')}
        icon="pi pi-refresh"
        iconPos="right"
        isDisabled={isRetakeDisabled}
        onClick={onRetake}
      />
    </StyledRetakeContainer>
  );
};
